import React, { ReactElement } from 'react';

import {
  Box,
  Button,
  ButtonPattern,
  Container,
  Grid,
  GridItem,
  Heading,
  Paragraph,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { useNavigate } from '@interstellar/react-app-routing';
import NeedHelpWrapper from 'components/needHelpWrapper/NeedHelpWrapper';
import PageHeading from 'components/pageHeading/PageHeading';
import StyledBox from 'components/style/styledBox/StyledBox';

import { SubmitYourRegistrationContent } from './SubmitYourRegistrationContent';
import { submitRegistrationDetails } from '../../api';
import { useGlobalProvider } from '../../context/GlobalContext';
import { CUS } from '../../utils/constant';
import { StyledImage } from '../fullSignatoryPage/FullSignatoryPage.styled';

function SubmitYourRegistration(): ReactElement {
  const { submitYourRegistrationContent } =
    useContent<SubmitYourRegistrationContent>();
  const [{ technicalErrorPageHref }] = submitYourRegistrationContent;
  const { globalState } = useGlobalProvider();
  const navigate = useNavigate();

  const handleNavigation = async (path: string): Promise<void> => {
    const { customerDetails, organisationName, sortCode, accountNumber } =
      globalState;

    const payload = {
      ...customerDetails,
      individual: {
        ...customerDetails?.individual,
        role: CUS,
      },
      organisation: {
        ...customerDetails?.organisation,
        name: organisationName,
        sortCode,
        accountNumber,
      },
      documents: [...(customerDetails?.documents || [])],
    };

    try {
      const response = await submitRegistrationDetails(payload);
      if (response.status === 200) {
        navigate(path);
      } else if (response.status === 500) {
        navigate(technicalErrorPageHref);
      }
    } catch (err) {
      console.log(err);
      navigate(technicalErrorPageHref);
    }
  };

  return (
    <Container padding="none">
      {submitYourRegistrationContent &&
        submitYourRegistrationContent.map(
          ({
            serviceName,
            header,
            imageSrc,
            imageAltText,
            verificationSuccess,
            haveEverything,
            submitRegistration,
            submitBtnHref,
          }) => (
            <React.Fragment key="content">
              <PageHeading serviceName={serviceName} header={header} />
              <Grid alignX="center" alignY="top">
                <GridItem lg={8}>
                  <StyledBox>
                    <Grid alignX="center" alignY="center">
                      <GridItem sm={12} md={6} lg={6}>
                        <Box
                          bgColor="none"
                          marginTop="07"
                          marginBottom="07"
                          padding="none"
                        >
                          <StyledImage alt={imageAltText} src={imageSrc} />
                        </Box>
                        <Heading align="center">{verificationSuccess}</Heading>
                      </GridItem>
                      <GridItem>
                        <Paragraph>{haveEverything}</Paragraph>
                      </GridItem>
                      <GridItem>
                        <ButtonPattern>
                          <Button
                            onClick={() => handleNavigation(submitBtnHref)}
                          >
                            {submitRegistration}
                          </Button>
                        </ButtonPattern>
                      </GridItem>
                    </Grid>
                  </StyledBox>
                </GridItem>

                <GridItem lg={4}>
                  <NeedHelpWrapper />
                </GridItem>
              </Grid>
            </React.Fragment>
          ),
        )}
    </Container>
  );
}

export default SubmitYourRegistration;
